import { Reducer } from "redux";
import { generateMetadataReducer } from "@montana/store/metadata-reducer";
import { IPageContainerState } from "./page";
import { PageActionTypes, IPageAction } from "./page.actions";
import { ErrorPageKind, AuthErrorKind } from "@montana/pages/dynamic-page.component";
import {IColorContentPage} from "@montana/models/generated/cms.interface";

const initialState: IPageContainerState = {
    isTransitioning: false
} as IPageContainerState;

const handleMetadata = generateMetadataReducer({
    fetchErrorActionName: PageActionTypes.FETCH_DATA_ERROR,
    fetchSuccessActionName: PageActionTypes.FETCH_DATA_SUCCESS,
    fetchStartActionName: PageActionTypes.FETCH_DATA,
});

export const pageReducer: Reducer<IPageContainerState, IPageAction> = (state = initialState, action): IPageContainerState => {

    const updatedState = handleMetadata(action);

    switch (action.type) {
        case PageActionTypes.FETCH_DATA: {
            return {
                ...state,
                ...updatedState
            };
        }
        case PageActionTypes.FETCH_DATA_SUCCESS: {
            let hasHero = false;
            let pageTheme = action.payload.backgroundColorHex;

            const firstBlock = (action.payload.topBlocks && action.payload.topBlocks.length)
                ? action.payload.topBlocks[0]
                : action.payload.blocks && action.payload.blocks.length && action.payload.blocks[0];
            if (firstBlock && firstBlock.kind === 'M01HeroBlock') {
                hasHero = true;
                if (firstBlock.backgroundColorHex) {
                    pageTheme = firstBlock.backgroundColorHex;
                }
            }
            if (action.payload.kind === 'ColorContentPage') {
                pageTheme = (action.payload as IColorContentPage).hexCode;
            }
            return {
                ...updatedState,
                ...action.payload,
                hasHero,
                pageTheme
            };
        }
        case PageActionTypes.SET_THEME: {
            return {
                ...state,
                pageTheme: action.hexColor,
            };
        }
        case PageActionTypes.SET_HERO: {
            return {
                ...state,
                hasHero: action.hasHero,
            };
        }
        case PageActionTypes.SET_TRANSITIONING: {
            return {
                ...state,
                isTransitioning: action.isTransitioning,
            };
        }
        case PageActionTypes.FETCH_DATA_ERROR: {
            return {
                ...state,
                ...updatedState,
                fetchError: {
                    ...action.error
                },
                kind: action.error.errorResponseCode === 401 ? AuthErrorKind : ErrorPageKind,
            };
        }
        default: {
            return state;
        }
    }
};
